import React, { useMemo } from 'react';
import { getInitials } from '../../utils/validations';

const DriverCard = ({
  driverDetails,
  selectedDriver,
  handleCardClick,
  className = 'bg-white',
}) => {
  const { firstName, lastName, id, email } = driverDetails || {};
  const initials = getInitials(firstName || email, lastName);

  const background = useMemo(() => {
    const colors = ['#FF922E80', '#13EF0066', '#D4002A80', '#13EF0066'];
    const randomIndex = Math.floor(Math.random() * colors.length)

    return selectedDriver?.id === id
      ? '#fff'
      : colors[randomIndex]
  }, [selectedDriver?.id, id]);

  const isSelected = useMemo(() => {
    return selectedDriver?.id === id;
  }, [selectedDriver?.id, id]);

  return (
    <li
      className={`flex w-full items-center gap-3 rounded-lg p-3 h-fit ${
        isSelected ? 'bg-black text-white' : className
      }`}
      role={handleCardClick && 'button'}
      onClick={handleCardClick && handleCardClick}
    >
      <h6
        className={`rounded-full text-center min-w-[40px] h-10 leading-10 ${
          isSelected && 'text-black'
        }`}
        style={{ background: isSelected ? '#fff' : background }}
      >
        {initials}
      </h6>
      <div className='overflow-hidden'>
        <h6>{lastName}</h6>
        <p title={email} className="text-disclaimer w-[170px] truncate">{email}</p>
      </div>
    </li>
  );
};

export default DriverCard;
